import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { hasPremiumAccess } from "@/lib/access";
import { Button } from "@/components/ui/button";

export default function Article() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const isPremium = hasPremiumAccess(user);

  useEffect(() => {
    api.get(`/articles/${slug}`).then(({ data }) => setA(data)).catch(() => setA(false)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="py-32 flex justify-center"><div className="h-8 w-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" /></div>;
  if (!a) return <div className="py-32 text-center text-neutral-400">Article not found.</div>;

  const locked = a.premium && !isPremium;

  return (
    <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
      <Link to="/news" className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-[#D4AF37] mb-8"><ArrowLeft size={15} /> Back to News</Link>
      <span className="text-xs font-mono uppercase text-[#D4AF37]">{a.category}</span>
      <h1 className="mt-3 font-display text-3xl md:text-5xl font-bold leading-tight">{a.title}</h1>
      <img src={a.cover} alt={a.title} className="mt-8 w-full h-72 object-cover border border-white/10" />
      <p className="mt-8 text-lg text-neutral-300 leading-relaxed">{a.excerpt}</p>

      {locked ? (
        <div className="mt-8 border border-[#D4AF37]/30 bg-[#111] p-10 text-center">
          <Lock className="mx-auto text-[#D4AF37]" size={28} />
          <h3 className="mt-4 font-display text-2xl font-bold">Members-only breakdown</h3>
          <p className="mt-3 text-neutral-400">This deeper analysis is reserved for Barbistry members. Upgrade to unlock premium content, education, and business lessons.</p>
          <Link to="/pricing" className="inline-block mt-6"><Button className="rounded-none bg-[#D4AF37] text-black hover:bg-[#F0C84B] font-semibold" data-testid="article-upgrade">Unlock with membership</Button></Link>
        </div>
      ) : (
        <div className="mt-6 text-neutral-300 leading-relaxed whitespace-pre-line">{a.body}</div>
      )}
    </article>
  );
}
